import {find} from 'lodash'

import {AppState} from '../../Root.store'

export const selectSites = (state: AppState) => state.sites

export const selectSite = (state: AppState, siteId: string) =>
  find(selectSites(state).sites, (site) => site.siteId === siteId)
